import PageIntro from "./PageIntro";

export default PageIntro;
